import React from 'react';
import {
  CarrierOption,
  carrierOptions
} from 'screens/Applications&WorkOrders/StepsLayout/Constants/selectOptions';
import { useAgOperationUtility } from 'screens/Applications&WorkOrders/StepsLayout/Context/AgOperationUtilityProvider';
import { Col, Radio, Row } from 'syngenta-digital-cropwise-react-ui-kit';

interface SelectCarrierRowProps {
  carrier: CarrierOption;
  selectedCarrier?: string;
  onChange: (carrierId: string) => void;
}

const SelectCarrierRow: React.FC<SelectCarrierRowProps> = ({
  carrier,
  selectedCarrier,
  onChange
}) => {
  const isSelected = selectedCarrier === carrier.id;

  return (
    <Row
      className={`h-60px items-center border-b border-neutral-20 cursor-pointer ${
        isSelected ? 'bg-blue-10 hover:bg-blue-20' : 'hover:bg-neutral-10'
      }`}
      onClick={() => onChange(carrier.id)}
    >
      <Col span={11} className="pl-8">
        <Row>{carrier.name}</Row>
        <Row className="text-xs text-neutral-60">{carrier.type}</Row>
      </Col>
      <Col flex="auto" className="pl-4 pr-52px">
        <Row justify="space-between">
          <Col>{carrier.standardUnit}</Col>
          <Col>
            <Radio checked={isSelected} onChange={() => onChange(carrier.id)} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const SelectCarrierStep = () => {
  const { utilityState, updateUtilityState } = useAgOperationUtility();

  const handleCarrierChange = (carrierId: string) => {
    updateUtilityState({ selectedCarrier: carrierId });
  };

  return (
    <div>
      <Row className="h-44px items-center bg-neutral-20">
        <Col span={11} className="font-semibold pl-8">
          Product Name
        </Col>
        <Col flex="auto" className="font-semibold pl-4">
          Standard Unit
        </Col>
      </Row>
      {carrierOptions.map(carrier => (
        <SelectCarrierRow
          key={carrier.id}
          carrier={carrier}
          selectedCarrier={utilityState.selectedCarrier}
          onChange={handleCarrierChange}
        />
      ))}
    </div>
  );
};

export default SelectCarrierStep;
